import React from 'react';
import { Field, FieldArray } from 'formik';
import { TextField } from 'formik-material-ui'; // import PropTypes from 'prop-types';
// import { Debug } from './Debug';

import { Grid, TextEditor, makeStyles, Typography, DatePicker, ChipGroup, SMCheckbox, CheckboxWithLabel, FormControlLabel } from '../../../../';
import selects from '../../../../assets/selects';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      'flex-wrap': 'no-wrap',
      padding: '20px'
    },
    form: {
      display: 'flex'
    },
    mr30: {
      'margin-right': '30px'
    },
    period: {
      width: '45px',
      margin: '0 12px'
    },
    labels: {
      margin: '8px 0'
    },
    flex: {
      display: 'flex',
      'flex-wrap': 'wrap',
      'padding-top': '10px'
    }
  };
});

var AddTaskForm = function AddTaskForm(_ref) {
  var values = _ref.values,
      mode = _ref.mode,
      translation = _ref.translation;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6,
    className: classes.editor
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "name",
    name: "name",
    fullWidth: true,
    label: translation ? translation.inputs.name : 'Task name',
    placeholder: translation ? translation.inputs.name : 'Task name',
    component: TextField,
    className: classes.mr30,
    margin: "normal",
    variant: "outlined",
    disabled: mode === 'view'
  }), /*#__PURE__*/React.createElement(Field, {
    name: "details",
    label: "Detalles"
  }, function (_ref2) {
    var field = _ref2.field;
    return /*#__PURE__*/React.createElement(TextEditor, {
      value: field.value,
      mode: mode,
      onChange: field.onChange(field.name)
    });
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "type",
    name: "type",
    label: translation ? translation.selects.recurrence.placeholder : 'Task type',
    className: classes.mr30,
    component: ChipGroup,
    margin: "normal",
    placeholder: translation ? translation.selects.recurrence.placeholder : 'Task Type',
    value: values.type,
    options: translation ? translation.selects.recurrence.items : selects.task_type,
    clickable: mode !== 'view'
  }), values.type === 'once' && [/*#__PURE__*/React.createElement(Field, {
    "data-cy": "date",
    name: "date",
    label: translation ? translation.inputs.date : 'Deadline',
    className: classes.mr30,
    component: DatePicker,
    format: "DD/MM/YYYY",
    value: values.date,
    disabled: mode === 'view'
  })], values.type === 'recurring' && [/*#__PURE__*/React.createElement(Field, {
    "data-cy": "start",
    name: "start",
    label: translation ? translation.inputs.start : 'Start date',
    className: classes.mr30,
    component: DatePicker,
    format: "DD/MM/YYYY",
    value: values.start,
    disabled: mode === 'view'
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "end",
    name: "end",
    label: translation ? translation.inputs.end : 'End date',
    className: classes.mr30,
    component: DatePicker,
    format: "DD/MM/YYYY",
    value: values.end,
    disabled: mode === 'view'
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "frequency",
    name: "frequency",
    label: translation ? translation.selects.frequency.placeholder : 'Repeats every...',
    className: classes.mr30,
    component: ChipGroup,
    margin: "normal",
    placeholder: translation ? translation.selects.frequency.placeholder : 'Repeats every...',
    value: values.frequency,
    options: translation ? translation.selects.frequency.items : selects.frequency,
    clickable: true
  })], values.type === 'recurring' && values.frequency && [/*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, values.frequency === 'day' && [/*#__PURE__*/React.createElement(Typography, {
    className: classes.labels,
    variant: "body1"
  }, translation ? translation.inputs.period.placeholder : 'Repeats every...'), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "period",
    name: "period",
    className: classes.period,
    component: TextField,
    type: "number",
    margin: "normal",
    value: values.period
  })], /*#__PURE__*/React.createElement(Typography, {
    className: classes.labels,
    variant: "caption"
  }, translation ? translation.inputs.period[values.frequency] : 'days'))], values.type === 'recurring' && values.frequency === 'week' && [/*#__PURE__*/React.createElement(FieldArray, {
    name: "weekdays",
    render: function render(_ref3) {
      var remove = _ref3.remove,
          push = _ref3.push;
      return /*#__PURE__*/React.createElement(Grid, {
        className: classes.flex,
        item: true,
        md: 12
      }, translation ? translation.selects.weekday.items.map(function (wday, index) {
        return /*#__PURE__*/React.createElement(SMCheckbox, {
          name: "weekdays",
          type: "checkbox",
          label: translation ? translation.selects.weekday.items[index].label : '',
          value: wday.value,
          checked: values.weekdays.includes(wday.value),
          onChange: function onChange(e) {
            if (e.target.checked) push(wday.value);else {
              var idx = values.weekdays.indexOf(wday.value);
              remove(idx);
            }
          }
        });
      }) : selects.weekday.map(function (wday, index) {
        return /*#__PURE__*/React.createElement(SMCheckbox, {
          name: "weekdays",
          type: "checkbox",
          label: selects ? selects.weekday[index].label : '',
          value: wday.value,
          checked: values.weekdays.includes(wday.value),
          onChange: function onChange(e) {
            if (e.target.checked) push(wday.value);else {
              var idx = values.weekdays.indexOf(wday.value);
              remove(idx);
            }
          }
        });
      }));
    }
  })], values.type === 'recurring' && values.frequency === 'month' && /*#__PURE__*/React.createElement(Grid, {
    className: classes.flex,
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.labels,
    variant: "body1"
  }, translation ? translation.inputs.monthday.day : 'On the'), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "monthday",
    name: "monthday",
    className: classes.period,
    component: TextField,
    type: "number",
    margin: "normal",
    value: values.period
  }), /*#__PURE__*/React.createElement(Typography, {
    className: classes.labels,
    variant: "body1"
  }, translation ? translation.inputs.monthday.each_month : 'of every month'))));
};

export { AddTaskForm };